import { render, staticRenderFns } from "./SidebarNavDivider.vue?vue&type=template&id=a4d35c90"
import script from "./SidebarNavDivider.vue?vue&type=script&lang=js"
export * from "./SidebarNavDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports